import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}
export function CtaButton({
  text = 'Acceder al Plan',
  onClick,
  className = '',
  fullWidth = false
}: CtaButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02,
    boxShadow: '0 0 20px rgba(245, 158, 11, 0.3)'
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick || (() => {
    const el = document.getElementById('precio');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  })} className={`
        relative overflow-hidden group
        bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500
        text-white font-bold text-lg py-4 px-8 rounded-xl
        shadow-lg shadow-amber-900/20 transition-all duration-300
        flex items-center justify-center gap-2
        ${fullWidth ? 'w-full' : 'w-full sm:w-auto'}
        ${className}
      `} data-id="element-16">
      <span data-id="element-17">{text}</span>
      <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-18" />
    </motion.button>;
}